import React from 'react';

const MoviesAdminHeroSection = () => {
  return (
    <section
      aria-labelledby="movies-admin-hero-title"
      className="site-bg-hero text-center py-16 px-6"
    >
      <p className="text-sm font-semibold uppercase tracking-[0.3em] text-sky-600">
        Area administrativa
      </p>
      <h1
        id="movies-admin-hero-title"
        className="mt-4 text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl"
      >
        Gerenciar listas de filmes
      </h1>
      <p className="mt-6 text-lg leading-8 text-gray-600 max-w-3xl mx-auto">
        Esta tela concentra o fluxo seguro de autenticacao e publicacao de novas entradas no
        repositório.
      </p>
    </section>
  );
};

export default MoviesAdminHeroSection;
